class SmallSpinnerController {
}

const smallSpinnerComponentDefinition = {
    controller: SmallSpinnerController,
    template: require('./small-spinner.component.html').trim(),
};

module.exports = {
    SmallSpinnerController,
    smallSpinnerComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/olycommon/loading-spinner/small-spinner.component.js